import React from "react"
import MUIDataTable from "mui-datatables";
import _ from "lodash";
import classnames from "classnames";

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Visibility';
import DuplicateIcon from '@material-ui/icons/ControlPointDuplicate';
import PrintIcon from '@material-ui/icons/Print';
import Button from '@material-ui/core/Button';
import Empty from './Empty';

const textLabels = {
    body: {
      noMatch: "Keine Einträge wurden gefunden!",
      toolTip: "Sortieren",
    },
    pagination: {
      next: "Nächste Seite",
      previous: "Vorherige Seite",
      rowsPerPage: "Zeilen pro Seite:",
      displayRows: "von",
    },
    toolbar: {
      search: "Suche",
      downloadCsv: "CSV",
      print: "Drucken",
      viewColumns: "Spalten anzeigen",
      filterTable: "Tabelle Filtern",
    },
    filter: {
      all: "Alle",
      title: "FILTER",
      reset: "ZURÜCKSETZEN",
    },
    viewColumns: {
      title: "Kopfzeile",
      titleAria: "Kopfzeile Einblenden/Ausblenden",
    },
    selectedRows: {
      text: "Zeile(n) ausgewählt",
      delete: "Löschen",
      deleteAria: "Ausgewählte Zeile löschen",
    },
}

class DeleteButton extends React.Component {
    render() {
        return(
            <div className="text-right">
                <Button color="secondary" size="small" onClick={this.props.onDelete}>
                    <DeleteForeverIcon />
                </Button>
            </div>
        )
    }
}

class DuplicateButton extends React.Component {
    render() {
        return(
            <div className="text-right">
                <Button color="primary" size="small" onClick={this.props.onDuplicate}>
                    <DuplicateIcon />
                </Button>
            </div>
        )
    }
}

class PrintButton extends React.Component {
    render() {
        return(
            <div className="text-right">
                <Button size="small" onClick={this.props.onPrint}>
                    <PrintIcon />
                </Button>
            </div>
        )
    }
}

export default class Table extends React.Component {

    // onChangePage
    // onChangeRowsPerPage
    // onSearchChange
    // onFilterChange
    // onColumnSortChange
    // onColumnViewChange
    // 
    
    state = {
        extendedClass: {}
    }

    currentPage = 0
    numberOfRows = 50

    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
            ...this.props
        }
        if(this.props.currentPage !== undefined) {
            this.currentPage = this.props.currentPage
        }
        if(this.props.numberOfRows !== undefined && this.numberOfRows === undefined) {
            this.numberOfRows = this.props.numberOfRows
        }
        if(this.state.rowClick && this.state.onDelete === undefined) {
            if(this.state.columns[this.state.columns.length-1] !== "") {
                this.state.columns.push("")
            }
            this.state.extendedClass["lastDisabled"] = true
        }
    }

    componentDidMount() {
        var numberOfRows = this.numberOfRows
        if(this.props.numberOfRows !== undefined) {
            numberOfRows = this.props.numberOfRows
        }
        var currentPage = this.currentPage
        if(this.props.currentPage !== undefined) {
            currentPage = this.props.currentPage
        }
        this.setState({
            numberOfRows, currentPage
        })
    }

    populate = () => {
        this.props.populate({
            currentPage: this.currentPage,
            numberOfRows: this.numberOfRows,
        })
    }

    onChangePage = (currentPage) => {
        this.currentPage = currentPage
        this.populate()
    }

    onCellClick = (colIndex, rowIndex) => {
        if(this.props.rowClick !== undefined && colIndex != this.props.columns.length) {
            this.props.rowClick(rowIndex, this.props.data[rowIndex])
        }
    }

    onChangeRowsPerPage = (numberOfRows) => {
        this.numberOfRows = numberOfRows
        this.populate()
    }

    onColumnSortChange = (changedColumn, direction) => {
        if(direction==="ascending") {
            direction = "asc"
        }
        if(direction==="descending") {
            direction = "desc"
        }
        this.state.sort = changedColumn+"__"+direction
        this.populate()
    }

    componentWillReceiveProps(props) {
        if(this.state !== props) {
            var numberOfRows = this.numberOfRows
            if(props.numberOfRows !== undefined) {
                numberOfRows = props.numberOfRows
            }
            var currentPage = this.currentPage
            if(props.currentPage !== undefined) {
                currentPage = props.currentPage
            }
            this.setState({
                ...this.state,
                ...props,
                numberOfRows,
                currentPage
            })
        }
    }

    render() {

        var {
            data,
            columns,
            populate,
            options,
            title,
            onDelete,
            onDuplicate,
            rowClick,
            noEmpty,
            currentPage,
            numberOfRows,
            count,
            extendedClass,
            onPrint
        } = this.state

        var optionsNew = {}
        if(options === undefined) {
            options = {}
        }

        optionsNew = {
            ...options,

            onCellClick: this.onCellClick,
            onChangePage: this.onChangePage,
            onChangeRowsPerPage: this.onChangeRowsPerPage,
            onColumnSortChange: this.onColumnSortChange,

            rowsPerPage: numberOfRows,
            rowsPerPageOptions: [5,10,15,50,100],
            count: count,
            page: currentPage+1,
            textLabels: textLabels,

            viewColumns: false,
            download: false,
            print: false,
            filter: false,
            sort: false,
            search: false,
            pagination: true,
            serverSide: true,
            responsive: "scroll"
        }

        if(optionsNew.page < 0) {
            optionsNew.page = 0
        }

        var newColumns = []

        var styleClass = {
            display: "flex",
            flexDirection: "row-reverse"
        }

        if ( onDelete !== undefined || onDuplicate !== undefined ) {
            newColumns = [
                ...columns,
                {
                    options: {
                        name: "Aktionen",
                        filter: false,
                        sort: false,
                        customBodyRender: (value, tableMeta, updateValue) => {
                            var customBodyRender = []
                            if(onDelete !== undefined && value !== null && value != undefined) {
                                if(value.value !== undefined) {
                                    var id = value.value
                                    if(value.delete) {
                                        customBodyRender.push(<DeleteButton onDelete={() => onDelete(id)} />)
                                    }
                                } else {
                                    customBodyRender.push(<DeleteButton onDelete={() => onDelete(value)} />)
                                }
                            }
                            if(onDuplicate !== undefined) {
                                customBodyRender.push(<DuplicateButton onDuplicate={() => onDuplicate(value)} />)
                            }
                            if(onPrint !== undefined) {
                                customBodyRender.push(<PrintButton onPrint={() => onPrint(value)} />)
                            }
                            return <div style={styleClass}>{customBodyRender}</div>
                        }
                    }
                }
            ]
        } else {
            newColumns = columns
        }

        if(noEmpty === undefined && (this.props.count === undefined || this.props.count === 0)) {
            return <Empty />
        }

        if(count > numberOfRows && (currentPage)*numberOfRows >= numberOfRows) {
            data = [
                ...Array((currentPage)*numberOfRows).fill([], 0),
                ...data
            ]
        }

        if(numberOfRows === count) {
            optionsNew.rowsPerPageOptions = false
            optionsNew.pagination = false
        }

        optionsNew.sortFilterList = false
        
        return(
            <div className={classnames(this.props.classes, extendedClass)}>
                <MUIDataTable
                    className={classnames(this.props.classes)}
                    key={title+currentPage}
                    title={title}
                    data={data}
                    columns={newColumns}
                    options={optionsNew}
                />
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/Components/Table.js